import { Link } from '@remix-run/react';
import {
    Button,
    Caption,
    Flex,
    pxToRem,
    useStyles,
} from '@archipro-design/aria';
import * as S from './Contacts.mobile.style';
import { useTracker } from '@archipro-website/tracker';
import type { ProjectPageLoader } from '@modules/project/type';
import SaveToDesignBoard from '@modules/design-board/component/SaveToDesignBoard';
import { useSaveToDesignBoard } from '~/modules/design-board/hook';
import { useEnquiryModal } from '~/modules-rocco/enquiry/hooks/use-enquiry-modal';

interface ContactsProps {
    project: ProjectPageLoader['project'];
}

const Contacts = ({
    project: { ID, Title, Professional, categoryPath },
}: ContactsProps) => {
    const { css } = useStyles();
    const tracker = useTracker();
    const { favouriteItem } = useSaveToDesignBoard({
        itemType: 'ProjectPin',
        itemId: ID,
    });

    const { openEnquiryModal } = useEnquiryModal({
        professional: Professional,
        itemType: 'project',
        siteTreeID: ID,
        relatedItem: {
            id: ID,
            type: 'project',
            title: Title,
            category: categoryPath,
        },
    });

    return (
        <Flex column className={css(S.Contacts)}>
            <div className={css(S.EnquireContainer)}>
                <Flex>
                    <Button
                        size={16}
                        color="dark"
                        className={css(S.EnquireButton)}
                        onClick={() => openEnquiryModal()}
                    >
                        ENQUIRE NOW
                    </Button>
                    <SaveToDesignBoard
                        heartButton={{
                            className: css(S.ButtonHeart),
                            color: 'primary',
                            variables: {
                                iconPadding: 0,
                                buttonPadding: 0,
                                primaryNoBKGButtonBackgroundColorHover:
                                    'transparent',
                            },
                            size: 20,
                        }}
                        {...favouriteItem}
                    />
                </Flex>
            </div>
            <Flex
                gap="space-20"
                className={css(S.SaveShareContainer)}
                hAlign="center"
                vAlign="center"
            >
                <Button
                    className={css(S.ProfileLink)}
                    as={Link}
                    to={Professional.Link}
                    size={16}
                    color="dark"
                    transparent
                    outlined
                    variables={{
                        buttonSize20LineHeight: '130%',
                        buttonPadding: pxToRem(15),
                        buttonMinWidth: 'fit-content',
                    }}
                    onClick={() => {
                        tracker.log('ProjectProfileButtonClick', {
                            url: new URL(window.location.href),
                            targetTracker: ['archiproTracker', 'ga4Tracker'],
                        });
                    }}
                >
                    VIEW PROFILE
                </Button>
            </Flex>
            {Professional.EnquiryResponseRate &&
            Professional.EnquiryResponseRate >= 40 ? (
                <div className={css(S.ResposeRate)}>
                    <Caption
                        variant="02"
                        variables={{
                            letterSpacing: 'normal',
                            fontSize: pxToRem(14),
                        }}
                    >
                        {`Responds within 24 hours: ${Professional.EnquiryResponseRate}%`}
                    </Caption>
                </div>
            ) : null}
        </Flex>
    );
};

export default Contacts;
